import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    text-align: center;
    min-height: 200px;
  `,
  button: css`
    z-index: 1;
    text-transform: none !important;
  `,
  buttonContainer: css`
    padding-bottom: 64px;
  `,
  illustrationContainer: css`
    display: flex;
    flex: 1;
    align-items: flex-end;
  `,
  illustration: css`
    object-fit: cover;
    width: 100%;
  `,
  dividerPadding: css`
    padding: 0px 16px 48px;
  `,
};

export default styles;
